import { checkDiff } from '../../../../utils/formValidation/errorCheckingFunctions';
import {
    getReqMessage,
    getSelectMessage
} from '../../../../utils/formValidation/errorMessageFunctions';

export const SNOMED_CODE_LIMIT = 20;
export const SNOMED_ID_LIMIT = 20;
export const DESCRIPTION_LIMIT = 500;

export const validate = (newEntry, initialState) => {
    let newErrors = {};

    if (!newEntry?.snomedCode.trim()) {
        newErrors.snomedCode = { error: true, message: getReqMessage('SNOMED code') };
    }
    if (!newEntry?.snomedId.trim()) {
        newErrors.snomedId = { error: true, message: getReqMessage('SNOMED ID') };
    }
    if (!newEntry?.emailTemplateId) {
        newErrors.emailTemplateId = {
            error: true,
            message: getSelectMessage('email template', 'an')
        };
    }
    if (!newEntry?.description.trim()) {
        newErrors.description = {
            error: true,
            message: getReqMessage('description')
        };
    }
    if (Object.keys(newErrors).length < 1) newErrors = checkDiff(newEntry, initialState);

    return newErrors;
};
